import { useEffect } from "react";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

// 滚动禁止/释放
export default function (element: Element) {
  useEffect(() => {
    disableBodyScroll(element);
    return () => {
      enableBodyScroll(element);
    };
  }, []);
}
